export default "__VITE_ASSET__D1MW1pCl__"